"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnergyEfficiency$ = exports.EnergyEfficiency$outboundSchema = exports.EnergyEfficiency$inboundSchema = void 0;
exports.energyEfficiencyToJSON = energyEfficiencyToJSON;
exports.energyEfficiencyFromJSON = energyEfficiencyFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const energyefficiencyratings_js_1 = require("./energyefficiencyratings.js");
/** @internal */
exports.EnergyEfficiency$inboundSchema = z.object({
    current_efficiency: z.number().int(),
    current_rating: energyefficiencyratings_js_1.EnergyEfficiencyRatings$inboundSchema,
    potential_efficiency: z.number().int(),
    potential_rating: energyefficiencyratings_js_1.EnergyEfficiencyRatings$inboundSchema,
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "current_efficiency": "currentEfficiency",
        "current_rating": "currentRating",
        "potential_efficiency": "potentialEfficiency",
        "potential_rating": "potentialRating",
    });
});
/** @internal */
exports.EnergyEfficiency$outboundSchema = z.object({
    currentEfficiency: z.number().int(),
    currentRating: energyefficiencyratings_js_1.EnergyEfficiencyRatings$outboundSchema,
    potentialEfficiency: z.number().int(),
    potentialRating: energyefficiencyratings_js_1.EnergyEfficiencyRatings$outboundSchema,
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        currentEfficiency: "current_efficiency",
        currentRating: "current_rating",
        potentialEfficiency: "potential_efficiency",
        potentialRating: "potential_rating",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var EnergyEfficiency$;
(function (EnergyEfficiency$) {
    /** @deprecated use `EnergyEfficiency$inboundSchema` instead. */
    EnergyEfficiency$.inboundSchema = exports.EnergyEfficiency$inboundSchema;
    /** @deprecated use `EnergyEfficiency$outboundSchema` instead. */
    EnergyEfficiency$.outboundSchema = exports.EnergyEfficiency$outboundSchema;
})(EnergyEfficiency$ || (exports.EnergyEfficiency$ = EnergyEfficiency$ = {}));
function energyEfficiencyToJSON(energyEfficiency) {
    return JSON.stringify(exports.EnergyEfficiency$outboundSchema.parse(energyEfficiency));
}
function energyEfficiencyFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.EnergyEfficiency$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'EnergyEfficiency' from JSON`);
}
//# sourceMappingURL=energyefficiency.js.map